import { alpha, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { CardSize } from '.';

const LARGE_CARD_ITEM_HEIGHT = 142;
const MEDIUM_CARD_ITEM_HEIGHT = 85;

interface CardStyledProps {
  isCardOver: boolean;
  size: CardSize;
}

export const useStyles = makeStyles<Theme, CardStyledProps>((theme) => ({
  empty: {
    color: theme.palette.grey[500],
  },
  imageFallback: {
    color: theme.palette.grey[300],
    fontSize: '4rem',
  },
  lockButton: ({ size }) => ({
    marginLeft: size === CardSize.LARGE ? theme.spacing(2) : theme.spacing(1),
    zIndex: 1,

    '& > button': {
      backgroundColor: theme.palette.primary.main,
      boxShadow: 'none',
      color: theme.palette.common.white,

      '&:hover': {
        boxShadow: 'none',
      },

      '& svg': {
        fill: theme.palette.common.white,
      },
    },
  }),
  mainTitle: {
    '@supports (-webkit-line-clamp: 2)': {
      '-webkit-box-orient': 'vertical',
      '-webkit-line-clamp': 1,
      display: '-webkit-box',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  media: {
    backgroundColor: theme.palette.grey[200],
    flex: '1 auto',
    height: ({ size }) =>
      size === CardSize.LARGE
        ? LARGE_CARD_ITEM_HEIGHT
        : MEDIUM_CARD_ITEM_HEIGHT,
    overflow: 'hidden',
    width: '100%',
  },
  brandkey: {
    position: 'absolute',
    color: 'white',
    backgroundColor: alpha(theme.palette.common.black, 0.6),
    top: 5,
    left: 5,
    margin: theme.spacing(1, 0, 0, 1),
    padding: theme.spacing(0, 0.5, 0, 0.5),
    zIndex: 1,
    borderRadius: 2,
  },
  innerWrapper: () => ({
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    position: 'relative',
    zIndex: 1,
    maxWidth: '100%',
    transition: theme.transitions.create('all', {
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  status: {
    marginTop: theme.spacing(3.25),
    width: 'fit-content',
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(0.25),
  },
  wrapper: ({ size }) => ({
    backgroundColor: theme.palette.common.white,
    border:
      size === CardSize.LARGE ? 'none' : `solid 1px ${theme.palette.grey[300]}`,
    boxShadow: 'none',
    height:
      size === CardSize.LARGE
        ? LARGE_CARD_ITEM_HEIGHT
        : MEDIUM_CARD_ITEM_HEIGHT,
    position: 'relative',
    transition: theme.transitions.create('all', {
      duration: theme.transitions.duration.leavingScreen,
    }),
  }),
  wrapperCenter: ({ size }) => ({
    height:
      size === CardSize.LARGE
        ? LARGE_CARD_ITEM_HEIGHT
        : MEDIUM_CARD_ITEM_HEIGHT,
    flex: '1 auto',
    padding:
      size === CardSize.LARGE
        ? theme.spacing(1.5, 1.5, 1.5, 3)
        : theme.spacing(1, 1, 1, 2),

    '& > h2': {
      color: theme.palette.grey['800'],
      fontWeight: 500,
      fontSize: size === CardSize.LARGE ? 20 : 16,
    },
  }),
  wrapperLeftSide: ({ size }) => ({
    maxWidth:
      size !== CardSize.LARGE
        ? MEDIUM_CARD_ITEM_HEIGHT * 1.5
        : LARGE_CARD_ITEM_HEIGHT * 2,
    minWidth:
      size !== CardSize.LARGE
        ? MEDIUM_CARD_ITEM_HEIGHT * 1.5
        : LARGE_CARD_ITEM_HEIGHT * 2,
    minHeight:
      size === CardSize.LARGE
        ? LARGE_CARD_ITEM_HEIGHT
        : MEDIUM_CARD_ITEM_HEIGHT,
    position: 'relative',
  }),
  wrapperActionsIcons: {
    alignItems: 'center',
    color: theme.palette.grey[400],
    display: 'flex',
    position: 'absolute',
    right: theme.spacing(1.75),
    top: theme.spacing(1),

    '& span': {
      alignItems: 'center',
      display: 'flex',

      '& > p': {
        color: theme.palette.grey['500'],
        fontSize: '.85rem',
        marginLeft: theme.spacing(0.5),
        paddingRight: theme.spacing(0.85),
      },

      '& svg': {
        fontSize: '1.75rem',
      },
    },
  },
  eventTitle: {
    fontWeight: 500,
    color: '#2e7d32',
    position: 'absolute',
    bottom: theme.spacing(1.5),
  },
  categoryTitle: {
    fontWeight: 500,
    color: '#4a90e2',
    position: 'absolute',
    bottom: theme.spacing(3.5),
  },
  wrapperRightSide: ({ size }) => ({
    alignItems: size === CardSize.LARGE ? 'flex-end' : 'center',
    display: 'flex',
    padding: theme.spacing(2, 2, 2, 0),
  }),
  paidArticle: {
    backgroundColor: 'rgb(243, 167, 18)',
    color: theme.palette.common.white,
    borderRadius: 2,
    fontSize: '.85rem',
    padding: theme.spacing(0, 0.4),
    margin: theme.spacing(0, 1, 0, 0),
  },
}));
